import React from "react";
import { View, StyleSheet } from "react-native";
import VernacManager from "utils/vernacular";
import OvalComponent from "./OvalComponent";

const OptionComponent = ({ options, responseValue, setResponseValue }) => (
  <View style={styles.container}>
    {options.map((option, i) => {
      return (
        <View key={`chip-${i}`} style={styles.optionContainer}>
          <OvalComponent
            text={
              VernacManager.translateString(option.vernacKey) || option.label
            }
            selected={option.value === responseValue}
            style={styles.optionSelect}
            onClick={() => {
              setResponseValue(option);
            }}
          />
        </View>
      );
    })}
  </View>
);

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 16
  },
  optionSelect: {
    paddingVertical: 3,
    fontSize: 12
  },
  optionContainer: { flexShrink: 1 }
});

export default OptionComponent;
